"use strict";

var _classCallCheck = require("/vercel/2c0a0396/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/2c0a0396/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Hub = /*#__PURE__*/function () {
  function Hub() {
    _classCallCheck(this, Hub);
  }

  _createClass(Hub, [{
    key: "getCode",
    value: function getCode() {}
  }, {
    key: "getScope",
    value: function getScope() {}
  }, {
    key: "addHelper",
    value: function addHelper() {
      throw new Error("Helpers are not supported by the default hub.");
    }
  }, {
    key: "buildError",
    value: function buildError(node, msg) {
      var Error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TypeError;
      return new Error(msg);
    }
  }]);

  return Hub;
}();

exports["default"] = Hub;